import React, { Fragment, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import FileSaver from "file-saver";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import MaterialTable, { MTableAction, MTableToolbar } from "material-table";
import DateFnsUtils from "@date-io/date-fns";
import Typography from "@material-ui/core/Typography";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Box from "@material-ui/core/Box";
import _ from "lodash";
import {
  getPMSDetails,
  updateMileStoneByRef,
  addMileStoneByRef,
  deleteMileStoneByRefAndSeq,
} from "../../../dataSource/pms";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
  DatePicker,
} from "@material-ui/pickers";
import LockScreenLoading from "../../LockScreenLoading/LockScreenLoading";
import moment from "moment";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import PrintIcon from "@material-ui/icons/Print";
// Material-UI Icon
import AddIcon from "@material-ui/icons/Add";
import { generatePdf } from "../../../dataSource/pil";
import { pmsDetailFormStyle } from "../../../styles/jss/components/PMS/pmsDetailFormStyle";
const useStyles = makeStyles((theme) => pmsDetailFormStyle(theme));

const PMS = (props) => {
  const classes = useStyles();
  const store = require("store");
  const dispatch = useDispatch();
  const [lockScreenLoadingOpen, setLockScreenLoadingOpen] = useState(false);
  const [progressTitle, setProgressTitle] = useState("");
  const [pmsDetails, setPmsDetails] = useState();

  const addActionRefkmd = React.useRef();
  const addActionRefkmsa = React.useRef();
  const addActionRefdmsa = React.useRef();
  const addActionRefkmla = React.useRef();

  const [tmpSeq, setTmpSeq] = useState(null);
  const [addFlag, setAddFlag] = useState(false);

  const [columns, setColumns] = useState([
    {
      title: "",
      field: "internal_action",
      editable: false,
      width: "2%",
      render: (rowData) =>
        rowData && (
          <IconButton
            style={{
              color: "black",
              padding: "2px",
              float: "left",
            }}
            onClick={() => {
              setTmpSeq(rowData.item_seq);
              if (rowData.ref === "kmsa") {
                addActionRefkmsa.current.click();
              } else if (rowData.ref === "dmsa") {
                addActionRefdmsa.current.click();
              } else if (rowData.ref === "kmla") {
                addActionRefkmla.current.click();
              } else {
                addActionRefkmd.current.click();
              }
            }}
          >
            <AddIcon />
          </IconButton>
        ),
    },
    {
      title: "Items",
      field: "item",
      width: "25%",
      render: (rowData) => {
        return `${rowData.tableData.id + 1}. ${rowData.item}`;
      },
    },
    {
      title: "Original Target Date",
      field: "orginaltargetdate",
      type: "date",
      width: "15%",
    },
    {
      title: "Revised Target Date",
      field: "revisedtargetdate",
      type: "date",
      width: "15%",
    },
    {
      title: "Actual Date",
      field: "actualdate",
      type: "date",
      width: "15%",
    },
    {
      title: "Remarks",
      field: "remarks",
      width: "15%",
    },
  ]);

  const fetchPMS = async () => {
    const response = await getPMSDetails();
    setPmsDetails(response.data);
  };

  const generatePMSPdf = async () => {
    setLockScreenLoadingOpen(true);
    let kmDevelopmentDisplayString = "";
    let kmSiteActivitiesDisplayString = "";
    let dmSiteActivitiesDisplayString = "";
    let kmLandScapeActivitiesDisplayString = "";

    for (let i = 0; i < pmsDetails.kmDevelopment.length; i++) {
      kmDevelopmentDisplayString = kmDevelopmentDisplayString.concat(`
      <tr>
      <td style="color:black;border:1px solid grey">
        <p>${Number(i) + 1}.${pmsDetails.kmDevelopment[i].item}</p>
      </td>
      <td style="color:black;border:1px solid grey">${
        pmsDetails.kmDevelopment[i].orginaltargetdate === null
          ? ""
          : moment(pmsDetails.kmDevelopment[i].orginaltargetdate).format(
              "YYYY/MM/DD"
            )
      }</td>
      <td style="color:black;border:1px solid grey">${
        pmsDetails.kmDevelopment[i].revisedtargetdate === null
          ? ""
          : moment(pmsDetails.kmDevelopment[i].revisedtargetdate).format(
              "YYYY/MM/DD"
            )
      }</td>
      <td style="color:black;border:1px solid grey">${
        pmsDetails.kmDevelopment[i].actualdate === null
          ? ""
          : moment(pmsDetails.kmDevelopment[i].actualdate).format("YYYY/MM/DD")
      }</td>
      <td style="color:black;border:1px solid grey">${
        pmsDetails.kmDevelopment[i].remarks === null
          ? ""
          : pmsDetails.kmDevelopment[i].remarks
      }</td>
    </tr>
    `);
    }
    for (let i = 0; i < pmsDetails.kmSiteActivities.length; i++) {
      kmSiteActivitiesDisplayString = kmSiteActivitiesDisplayString.concat(`
      <tr>
      <td style="color:black;border:1px solid grey">
        <p>${Number(i) + 1}.${pmsDetails.kmSiteActivities[i].item}</p>
      </td>
      <td style="color:black;border:1px solid grey">${
        pmsDetails.kmSiteActivities[i].orginaltargetdate === null
          ? ""
          : moment(pmsDetails.kmSiteActivities[i].orginaltargetdate).format(
              "YYYY/MM/DD"
            )
      }</td>
      <td style="color:black;border:1px solid grey">${
        pmsDetails.kmSiteActivities[i].revisedtargetdate === null
          ? ""
          : moment(pmsDetails.kmSiteActivities[i].revisedtargetdate).format(
              "YYYY/MM/DD"
            )
      }</td>
      <td style="color:black;border:1px solid grey">${
        pmsDetails.kmSiteActivities[i].actualdate === null
          ? ""
          : moment(pmsDetails.kmSiteActivities[i].actualdate).format(
              "YYYY/MM/DD"
            )
      }</td>
      <td style="color:black;border:1px solid grey">${
        pmsDetails.kmSiteActivities[i].remarks === null
          ? ""
          : pmsDetails.kmSiteActivities[i].remarks
      }</td>
    </tr>
    `);
    }
    for (let i = 0; i < pmsDetails.dmSiteActivities.length; i++) {
      dmSiteActivitiesDisplayString = dmSiteActivitiesDisplayString.concat(`
      <tr>
      <td style="color:black;line-height:20px;border:1px solid grey">
        <p>${Number(i) + 1}.${pmsDetails.dmSiteActivities[i].item}</p>
      </td>
      <td style="color:black;border:1px solid grey">${
        pmsDetails.dmSiteActivities[i].orginaltargetdate === null
          ? ""
          : moment(pmsDetails.dmSiteActivities[i].orginaltargetdate).format(
              "YYYY/MM/DD"
            )
      }</td>
      <td style="color:black;border:1px solid grey">${
        pmsDetails.dmSiteActivities[i].revisedtargetdate === null
          ? ""
          : moment(pmsDetails.dmSiteActivities[i].revisedtargetdate).format(
              "YYYY/MM/DD"
            )
      }</td>
      <td style="color:black;border:1px solid grey">${
        pmsDetails.dmSiteActivities[i].actualdate === null
          ? ""
          : moment(pmsDetails.dmSiteActivities[i].actualdate).format(
              "YYYY/MM/DD"
            )
      }</td>
      <td style="color:black;border:1px solid grey">${
        pmsDetails.dmSiteActivities[i].remarks === null
          ? ""
          : pmsDetails.dmSiteActivities[i].remarks
      }</td>
    </tr>
    `);
    }
    for (let i = 0; i < pmsDetails.kmLandScapeActivities.length; i++) {
      kmLandScapeActivitiesDisplayString =
        kmLandScapeActivitiesDisplayString.concat(`
      <tr>
      <td style="color:black;border:1px solid grey">
        <p>${Number(i) + 1}.${pmsDetails.kmLandScapeActivities[i].item}</p>
      </td>
      <td style="color:black;border:1px solid grey">${
        pmsDetails.kmLandScapeActivities[i].orginaltargetdate === null
          ? ""
          : moment(
              pmsDetails.kmLandScapeActivities[i].orginaltargetdate
            ).format("YYYY/MM/DD")
      }</td>
      <td style="color:black;border:1px solid grey">${
        pmsDetails.kmLandScapeActivities[i].revisedtargetdate === null
          ? ""
          : moment(
              pmsDetails.kmLandScapeActivities[i].revisedtargetdate
            ).format("YYYY/MM/DD")
      }</td>
      <td style="color:black;border:1px solid grey">${
        pmsDetails.kmLandScapeActivities[i].actualdate === null
          ? ""
          : moment(pmsDetails.kmLandScapeActivities[i].actualdate).format(
              "YYYY/MM/DD"
            )
      }</td>
      <td style="color:black;border:1px solid grey">${
        pmsDetails.kmLandScapeActivities[i].remarks === null
          ? ""
          : pmsDetails.kmLandScapeActivities[i].remarks
      }</td>
    </tr>
    `);
    }
    let kmDevelopmentTemplate = `
    <p>Key Milestone for the Development</p>   
    <table style="border-style: solid;border-width:1px;border-color:grey;width: 100%; page-break-after: always;">
           <thead>
           <tr style="background-color: rgb(238, 238, 238)">
           <th style="width:45%;align:center;color:black"><strong>Items</strong></th>
           <th style="width:10%;align:center;color:black"><strong>Original Target Date</strong></th>
           <th style="width:10%;align:center;color:black"><strong>Revised Target Date</strong></th>
           <th style="width:10%;align:center;color:black"><strong>Actual Date</strong></th>
           <th style="width:25%;align:center;color:black"><strong>Remarks</strong></th>
           </tr>
           </thead>
           <tbody>             
            ${kmDevelopmentDisplayString}           
         </tbody>
       </table>
  `;
    let kmSiteActivitiesTemplate = `
   <p>Key Milestone for Site Activities</p>   
   <table style="border-style: solid;border-width:1px;border-color:grey;width: 100%; page-break-after: always;">
          <thead>
          <tr style="background-color: rgb(238, 238, 238)">
          <th style="width:45%;align:center;color:black"><strong>Items</strong></th>
          <th style="width:10%;align:center;color:black"><strong>Original Target Date</strong></th>
          <th style="width:10%;align:center;color:black"><strong>Revised Target Date</strong></th>
          <th style="width:10%;align:center;color:black"><strong>Actual Date</strong></th>
          <th style="width:25%;align:center;color:black"><strong>Remarks</strong></th>
          </tr>
          </thead>
          <tbody>             
           ${kmSiteActivitiesDisplayString}     
        </tbody>
      </table>`;
    let dmSiteActivitiesTemplate = `
   <p>Detail Milestone for Site Activities</p>   
   <table style="border-style: solid;border-width:1px;border-color:grey;width: 100%; page-break-after: always;">
          <thead>
          <tr style="background-color: rgb(238, 238, 238)">
          <th style="width:45%;align:center;color:black"><strong>Items</strong></th>
          <th style="width:10%;align:center;color:black"><strong>Original Target Date</strong></th>
          <th style="width:10%;align:center;color:black"><strong>Revised Target Date</strong></th>
          <th style="width:10%;align:center;color:black"><strong>Actual Date</strong></th>
          <th style="width:25%;align:center;color:black"><strong>Remarks</strong></th>
          </tr>
          </thead>
          <tbody>             
           ${dmSiteActivitiesDisplayString}     
        </tbody>
      </table>
  `;
    let kmLandScapeActivitiesTemplate = `
   <p>Key Milestone for Landscaping Activities</p>   
      <table style="border-style: solid;border-width:1px;border-color:grey;width: 100%;">
          <thead>
          <tr style="background-color: rgb(238, 238, 238)">
            <th style="width:45%;align:center;color:black"><strong>Items</strong></th>
            <th style="width:10%;align:center;color:black"><strong>Original Target Date</strong></th>
            <th style="width:10%;align:center;color:black"><strong>Revised Target Date</strong></th>
            <th style="width:10%;align:center;color:black"><strong>Actual Date</strong></th>
            <th style="width:25%;align:center;color:black"><strong>Remarks</strong></th>
          </tr>
          </thead>
          <tbody>             
           ${kmLandScapeActivitiesDisplayString}   
        </tbody>
      </table>
      <br /><br /><br /><br />
      <div style="width:100%;border-top:1px solid black;text-align:center">
       <h3 style="font-weight:bold;">Endorsed By</h3>
       </div>
      <br />
      
`;
    let htmlStr = `
      <html>
        <head>
            <meta charset="utf-8">
            <style>     
            @media print{  
            }
        </style>
        </head>
        <body>
        <div style="font-size: 9px;margin:0;">     
        <div style='text-align:center'><h3>Project Milestone Schedule</h3></div>
        ${kmDevelopmentTemplate}
        ${kmSiteActivitiesTemplate}
        ${dmSiteActivitiesTemplate}
        ${kmLandScapeActivitiesTemplate}
          </div>    
        </body>
    </html>
  `;

    const pdf = await generatePdf(htmlStr, "");
    FileSaver.saveAs(
      pdf,
      `Project Milestone Schedule - ${store.get("site_code")}.pdf`
    );
    setLockScreenLoadingOpen(false);
  };

  useEffect(() => {
    const fetchPMSDetails = async () => {
      await fetchPMS();
    };
    fetchPMSDetails();
  }, [addFlag]);

  return (
    <Fragment>
      <LockScreenLoading
        open={lockScreenLoadingOpen}
        circleSize={200}
        progressTitle={progressTitle}
      />
      <Box>
        <AppBar position="static" color="transparent">
          <Toolbar>
            <Typography variant="h6" className={classes.appbarTest}>
              Project Milestone Schedule
            </Typography>
          </Toolbar>
        </AppBar>
      </Box>
      <Tooltip title="Print PDF">
        <IconButton
          aria-label="add"
          onClick={() => {
            generatePMSPdf();
          }}
        >
          <PrintIcon />
        </IconButton>
      </Tooltip>

      {pmsDetails && (
        <>
          <MaterialTable
            // columns={columns.map((c) => ({ ...c, tableData: undefined }))}
            title={"Key Milestone for the Development"}
            columns={columns}
            data={pmsDetails.kmDevelopment}
            editable={{
              isDeleteHidden: (rowData) => rowData.template === "Y",
              onRowUpdate: (newData, oldData) =>
                new Promise((resolve, reject) => {
                  setTimeout(async () => {
                    const dataUpdate = [...pmsDetails.kmDevelopment];
                    const index = oldData.tableData.id;
                    dataUpdate[index] = newData;
                    await updateMileStoneByRef("kmd", newData).then((res) => {
                      setPmsDetails({
                        ...pmsDetails,
                        kmDevelopment: dataUpdate,
                      });
                    });
                    resolve();
                  }, 1000);
                }),
              onRowDelete: (oldData) =>
                new Promise((resolve, reject) => {
                  setTimeout(async () => {
                    const dataDelete = [...pmsDetails.kmDevelopment];
                    const index = oldData.tableData.id;
                    dataDelete.splice(index, 1);
                    await deleteMileStoneByRefAndSeq(
                      "kmd",
                      oldData.km_dev_seq
                    ).then((res) => {
                      setPmsDetails({
                        ...pmsDetails,
                        kmDevelopment: dataDelete,
                      });
                    });

                    resolve();
                  }, 1000);
                }),
              onRowAdd: (newData) =>
                new Promise((resolve, reject) => {
                  setTimeout(async () => {
                    let example = [...pmsDetails.kmDevelopment];

                    let exampleData = {
                      flag: "NEW",
                      pms_seq: pmsDetails.kmDevelopment[0].pms_seq,
                      template: "N",
                      ref: "kmd",
                      item: newData.item,
                      item_seq: Number(tmpSeq) + 1,
                      orginaltargetdate:
                        newData.orginaltargetdate === null
                          ? ""
                          : newData.orginaltargetdate,
                      revisedtargetdate:
                        newData.revisedtargetdate === null
                          ? ""
                          : newData.revisedtargetdate,
                      actualdate:
                        newData.actualdate === null ? "" : newData.actualdate,
                      remarks: newData.remarks,
                    };
                    let index = pmsDetails.kmDevelopment.findIndex(
                      (obj) => obj.item_seq == tmpSeq
                    );
                    example.splice(index + 1, 0, exampleData);
                    example = _.union(
                      example
                        .filter(
                          (obj) =>
                            Number(obj.item_seq) <= tmpSeq || obj.flag === "NEW"
                        )
                        .map((jobj) => {
                          return {
                            pms_seq: jobj.pms_seq,
                            item: jobj.item,
                            item_seq: Number(jobj.item_seq),
                            ref: "kmd",
                            orginaltargetdate:
                              jobj.orginaltargetdate === undefined
                                ? null
                                : jobj.orginaltargetdate,
                            revisedtargetdate:
                              jobj.revisedtargetdate === undefined
                                ? null
                                : jobj.revisedtargetdate,
                            actualdate:
                              jobj.actualdate === undefined
                                ? null
                                : jobj.actualdate,
                            remarks: jobj.remarks,
                            template: jobj.template,
                            ref: jobj.ref,
                          };
                        }),
                      example
                        .filter(
                          (obj) =>
                            Number(obj.item_seq) > tmpSeq && obj.flag !== "NEW"
                        )
                        .map((jobj) => {
                          return {
                            pms_seq: jobj.pms_seq,
                            item: jobj.item,
                            item_seq: Number(jobj.item_seq) + 1,
                            ref: "kmd",
                            orginaltargetdate:
                              jobj.orginaltargetdate === undefined
                                ? null
                                : jobj.orginaltargetdate,
                            revisedtargetdate:
                              jobj.revisedtargetdate === undefined
                                ? null
                                : jobj.revisedtargetdate,
                            actualdate:
                              jobj.actualdate === undefined
                                ? null
                                : jobj.actualdate,
                            remarks: jobj.remarks,
                            template: jobj.template,
                            ref: jobj.ref,
                          };
                        })
                    );
                    // setTableData([...example]);

                    let insertBody = {};
                    insertBody.details = example;

                    await addMileStoneByRef("kmd", insertBody).then((res) => {
                      setPmsDetails({
                        ...pmsDetails,
                        kmDevelopment: example,
                      });
                      setTmpSeq(null);
                      setAddFlag(!addFlag);
                    });

                    resolve();
                  });
                }, 1000),
            }}
            components={{
              Action: (props) => {
                //If isn't the add action
                if (
                  typeof props.action === typeof Function ||
                  props.action.tooltip !== "Add"
                ) {
                  return <MTableAction {...props} />;
                } else {
                  return (
                    <div
                      ref={addActionRefkmd}
                      onClick={(event) =>
                        props.action.onClick(event, props.data)
                      }
                    />
                  );
                }
              },
            }}
            localization={{
              header: {
                actions: "",
              },
            }}
            options={{
              paging: false,
              search: false,
              padding: "dense",
            }}
          />
          <MaterialTable
            title={"Key Milestone for Site Activities"}
            columns={columns}
            data={pmsDetails.kmSiteActivities}
            editable={{
              isDeleteHidden: (rowData) => rowData.template === "Y",
              onRowUpdate: (newData, oldData) =>
                new Promise((resolve, reject) => {
                  setTimeout(async () => {
                    const dataUpdate = [...pmsDetails.kmSiteActivities];
                    const index = oldData.tableData.id;
                    dataUpdate[index] = newData;
                    await updateMileStoneByRef("kmsa", newData).then((res) => {
                      setPmsDetails({
                        ...pmsDetails,
                        kmSiteActivities: dataUpdate,
                      });
                    });

                    resolve();
                  }, 1000);
                }),
              onRowDelete: (oldData) =>
                new Promise((resolve, reject) => {
                  setTimeout(async () => {
                    const dataDelete = [...pmsDetails.kmSiteActivities];
                    const index = oldData.tableData.id;
                    dataDelete.splice(index, 1);
                    await deleteMileStoneByRefAndSeq(
                      "kmsa",
                      oldData.km_site_act_seq
                    ).then((res) => {
                      setPmsDetails({
                        ...pmsDetails,
                        kmSiteActivities: dataDelete,
                      });
                    });

                    resolve();
                  }, 1000);
                }),
              onRowAdd: (newData) =>
                new Promise((resolve, reject) => {
                  setTimeout(async () => {
                    let example = [...pmsDetails.kmSiteActivities];
                    let exampleData = {
                      flag: "NEW",
                      pms_seq: pmsDetails.kmSiteActivities[0].pms_seq,
                      template: "N",
                      ref: "kmsa",
                      item: newData.item,
                      item_seq: Number(tmpSeq) + 1,
                      originaltargetdate:
                        newData.originaltargetdate === null
                          ? ""
                          : newData.originaltargetdate,
                      revisedtargetdate:
                        newData.revisedtargetdate === null
                          ? ""
                          : newData.revisedtargetdate,
                      actualdate:
                        newData.actualdate === null ? "" : newData.actualdate,
                      remarks: newData.remarks,
                    };

                    let index = pmsDetails.kmSiteActivities.findIndex(
                      (obj) => obj.item_seq == tmpSeq
                    );
                    example.splice(index + 1, 0, exampleData);
                    example = _.union(
                      example
                        .filter(
                          (obj) =>
                            Number(obj.item_seq) <= tmpSeq || obj.flag === "NEW"
                        )
                        .map((jobj) => {
                          return {
                            pms_seq: jobj.pms_seq,
                            item: jobj.item,
                            item_seq: Number(jobj.item_seq),
                            orginaltargetdate:
                              jobj.orginaltargetdate === undefined
                                ? null
                                : jobj.orginaltargetdate,
                            revisedtargetdate:
                              jobj.revisedtargetdate === undefined
                                ? null
                                : jobj.revisedtargetdate,
                            actualdate:
                              jobj.actualdate === undefined
                                ? null
                                : jobj.actualdate,
                            remarks: jobj.remarks,
                            template: jobj.template,
                            ref: jobj.ref,
                          };
                        }),
                      example
                        .filter(
                          (obj) =>
                            Number(obj.item_seq) > tmpSeq && obj.flag !== "NEW"
                        )
                        .map((jobj) => {
                          return {
                            pms_seq: jobj.pms_seq,
                            item: jobj.item,
                            item_seq: Number(jobj.item_seq) + 1,
                            orginaltargetdate:
                              jobj.orginaltargetdate === undefined
                                ? null
                                : jobj.orginaltargetdate,
                            revisedtargetdate:
                              jobj.revisedtargetdate === undefined
                                ? null
                                : jobj.revisedtargetdate,
                            actualdate:
                              jobj.actualdate === undefined
                                ? null
                                : jobj.actualdate,
                            remarks: jobj.remarks,
                            template: jobj.template,
                            ref: jobj.ref,
                          };
                        })
                    );
                    let insertBody = {};
                    insertBody.details = example;

                    await addMileStoneByRef("kmsa", insertBody).then((res) => {
                      setPmsDetails({
                        ...pmsDetails,
                        kmSiteActivities: example,
                      });
                      setTmpSeq(null);
                      setAddFlag(!addFlag);
                    });
                    resolve();
                  }, 1000);
                }),
            }}
            components={{
              Action: (props) => {
                //If isn't the add action
                if (
                  typeof props.action === typeof Function ||
                  props.action.tooltip !== "Add"
                ) {
                  return <MTableAction {...props} />;
                } else {
                  return (
                    <div
                      ref={addActionRefkmsa}
                      onClick={(event) =>
                        props.action.onClick(event, props.data)
                      }
                    />
                  );
                }
              },
            }}
            localization={{
              header: {
                actions: "",
              },
            }}
            options={{
              paging: false,
              search: false,
              header: false,
              padding: "dense",
            }}
          />
          <MaterialTable
            title={"Detail Milestone for Site Activities"}
            columns={columns}
            data={pmsDetails.dmSiteActivities}
            editable={{
              isDeleteHidden: (rowData) => rowData.template === "Y",

              onRowUpdate: (newData, oldData) =>
                new Promise((resolve, reject) => {
                  setTimeout(async () => {
                    const dataUpdate = [...pmsDetails.dmSiteActivities];
                    const index = oldData.tableData.id;
                    dataUpdate[index] = newData;
                    await updateMileStoneByRef("dmsa", newData).then((res) => {
                      setPmsDetails({
                        ...pmsDetails,
                        dmSiteActivities: dataUpdate,
                      });
                    });
                    resolve();
                  }, 1000);
                }),
              onRowDelete: (oldData) =>
                new Promise((resolve, reject) => {
                  setTimeout(async () => {
                    const dataDelete = [...pmsDetails.dmSiteActivities];
                    const index = oldData.tableData.id;
                    dataDelete.splice(index, 1);
                    await deleteMileStoneByRefAndSeq(
                      "dmsa",
                      oldData.dm_site_act_seq
                    ).then((res) => {
                      setPmsDetails({
                        ...pmsDetails,
                        dmSiteActivities: dataDelete,
                      });
                    });

                    resolve();
                  }, 1000);
                }),
              onRowAdd: (newData) =>
                new Promise((resolve, reject) => {
                  setTimeout(async () => {
                    let example = [...pmsDetails.dmSiteActivities];
                    let exampleData = {
                      pms_seq: pmsDetails.dmSiteActivities[0].pms_seq,
                      flag: "NEW",
                      template: "N",
                      ref: "dmsa",
                      item: newData.item,
                      item_seq: Number(tmpSeq) + 1,
                      originaltargetdate:
                        newData.originaltargetdate === null
                          ? ""
                          : newData.originaltargetdate,
                      revisedtargetdate:
                        newData.revisedtargetdate === null
                          ? ""
                          : newData.revisedtargetdate,
                      actualdate:
                        newData.actualdate === null ? "" : newData.actualdate,
                      remarks: newData.remarks,
                    };
                    let index = pmsDetails.dmSiteActivities.findIndex(
                      (obj) => obj.item_seq == tmpSeq
                    );
                    example.splice(index + 1, 0, exampleData);
                    example = _.union(
                      example
                        .filter(
                          (obj) =>
                            Number(obj.item_seq) <= tmpSeq || obj.flag === "NEW"
                        )
                        .map((jobj) => {
                          return {
                            pms_seq: jobj.pms_seq,
                            item: jobj.item,
                            item_seq: Number(jobj.item_seq),
                            orginaltargetdate:
                              jobj.orginaltargetdate === undefined
                                ? null
                                : jobj.orginaltargetdate,
                            revisedtargetdate:
                              jobj.revisedtargetdate === undefined
                                ? null
                                : jobj.revisedtargetdate,
                            actualdate:
                              jobj.actualdate === undefined
                                ? null
                                : jobj.actualdate,
                            remarks: jobj.remarks,
                            template: jobj.template,
                            ref: jobj.ref,
                          };
                        }),
                      example
                        .filter(
                          (obj) =>
                            Number(obj.item_seq) > tmpSeq && obj.flag !== "NEW"
                        )
                        .map((jobj) => {
                          return {
                            pms_seq: jobj.pms_seq,
                            item: jobj.item,
                            item_seq: Number(jobj.item_seq) + 1,
                            orginaltargetdate:
                              jobj.orginaltargetdate === undefined
                                ? null
                                : jobj.orginaltargetdate,
                            revisedtargetdate:
                              jobj.revisedtargetdate === undefined
                                ? null
                                : jobj.revisedtargetdate,
                            actualdate:
                              jobj.actualdate === undefined
                                ? null
                                : jobj.actualdate,
                            remarks: jobj.remarks,
                            template: jobj.template,
                            ref: jobj.ref,
                          };
                        })
                    );
                    let insertBody = {};
                    insertBody.details = example;

                    await addMileStoneByRef("dmsa", insertBody).then((res) => {
                      setPmsDetails({
                        ...pmsDetails,
                        dmSiteActivities: example,
                      });
                      setTmpSeq(null);
                      setAddFlag(!addFlag);
                    });
                    resolve();
                  }, 1000);
                }),
            }}
            components={{
              Action: (props) => {
                //If isn't the add action
                if (
                  typeof props.action === typeof Function ||
                  props.action.tooltip !== "Add"
                ) {
                  return <MTableAction {...props} />;
                } else {
                  return (
                    <div
                      ref={addActionRefdmsa}
                      onClick={(event) =>
                        props.action.onClick(event, props.data)
                      }
                    />
                  );
                }
              },
            }}
            localization={{
              header: {
                actions: "",
              },
            }}
            options={{
              paging: false,
              search: false,
              header: false,
              padding: "dense",
            }}
          />
          <MaterialTable
            title={"Key Milestone for Landscaping Activities"}
            columns={columns}
            data={pmsDetails.kmLandScapeActivities}
            editable={{
              isDeleteHidden: (rowData) => rowData.template === "Y",
              onRowUpdate: (newData, oldData) =>
                new Promise((resolve, reject) => {
                  setTimeout(async () => {
                    const dataUpdate = [...pmsDetails.kmLandScapeActivities];
                    const index = oldData.tableData.id;
                    dataUpdate[index] = newData;
                    await updateMileStoneByRef("kmla", newData).then((res) => {
                      setPmsDetails({
                        ...pmsDetails,
                        kmLandScapeActivities: dataUpdate,
                      });
                    });
                    resolve();
                  }, 1000);
                }),
              onRowDelete: (oldData) =>
                new Promise((resolve, reject) => {
                  setTimeout(async () => {
                    const dataDelete = [...pmsDetails.kmLandScapeActivities];
                    const index = oldData.tableData.id;
                    dataDelete.splice(index, 1);
                    await deleteMileStoneByRefAndSeq(
                      "kmla",
                      oldData.km_landscape_act_seq
                    ).then((res) => {
                      setPmsDetails({
                        ...pmsDetails,
                        kmLandScapeActivities: dataDelete,
                      });
                    });

                    resolve();
                  }, 1000);
                }),
              onRowAdd: (newData) =>
                new Promise((resolve, reject) => {
                  setTimeout(async () => {
                    let example = [...pmsDetails.kmLandScapeActivities];
                    let exampleData = {
                      flag: "NEW",
                      pms_seq: pmsDetails.kmLandScapeActivities[0].pms_seq,
                      template: "N",
                      ref: "kmla",
                      item: newData.item,
                      item_seq: Number(tmpSeq) + 1,
                      originaltargetdate:
                        newData.originaltargetdate === null
                          ? ""
                          : newData.originaltargetdate,
                      revisedtargetdate:
                        newData.revisedtargetdate === null
                          ? ""
                          : newData.revisedtargetdate,
                      actualdate:
                        newData.actualdate === null ? "" : newData.actualdate,
                      remarks: newData.remarks,
                    };
                    let index = pmsDetails.kmLandScapeActivities.findIndex(
                      (obj) => obj.item_seq == tmpSeq
                    );
                    example.splice(index + 1, 0, exampleData);
                    example = _.union(
                      example
                        .filter(
                          (obj) =>
                            Number(obj.item_seq) <= tmpSeq || obj.flag === "NEW"
                        )
                        .map((jobj) => {
                          return {
                            pms_seq: jobj.pms_seq,
                            item: jobj.item,
                            item_seq: Number(jobj.item_seq),
                            orginaltargetdate:
                              jobj.orginaltargetdate === undefined
                                ? null
                                : jobj.orginaltargetdate,
                            revisedtargetdate:
                              jobj.revisedtargetdate === undefined
                                ? null
                                : jobj.revisedtargetdate,
                            actualdate:
                              jobj.actualdate === undefined
                                ? null
                                : jobj.actualdate,
                            remarks: jobj.remarks,
                            template: jobj.template,
                            ref: jobj.ref,
                          };
                        }),
                      example
                        .filter(
                          (obj) =>
                            Number(obj.item_seq) > tmpSeq && obj.flag !== "NEW"
                        )
                        .map((jobj) => {
                          return {
                            pms_seq: jobj.pms_seq,
                            item: jobj.item,
                            item_seq: Number(jobj.item_seq) + 1,
                            orginaltargetdate:
                              jobj.orginaltargetdate === undefined
                                ? null
                                : jobj.orginaltargetdate,
                            revisedtargetdate:
                              jobj.revisedtargetdate === undefined
                                ? null
                                : jobj.revisedtargetdate,
                            actualdate:
                              jobj.actualdate === undefined
                                ? null
                                : jobj.actualdate,
                            remarks: jobj.remarks,
                            template: jobj.template,
                            ref: jobj.ref,
                          };
                        })
                    );
                    let insertBody = {};
                    insertBody.details = example;

                    await addMileStoneByRef("kmla", insertBody).then((res) => {
                      setPmsDetails({
                        ...pmsDetails,
                        kmLandScapeActivities: example,
                      });
                      setTmpSeq(null);
                      setAddFlag(!addFlag);
                    });
                    resolve();
                  }, 1000);
                }),
            }}
            components={{
              Action: (props) => {
                if (
                  typeof props.action === typeof Function ||
                  props.action.tooltip !== "Add"
                ) {
                  return <MTableAction {...props} />;
                } else {
                  return (
                    <>
                      <div
                        ref={addActionRefkmla}
                        onClick={(event) => {
                          props.action.onClick(event, props.data);
                        }}
                      />
                    </>
                  );
                }
              },
            }}
            localization={{
              header: {
                actions: "",
              },
            }}
            options={{
              paging: false,
              search: false,
              header: false,
              padding: "dense",
            }}
          />
        </>
      )}
    </Fragment>
  );
};

export default PMS;
